import { jsxs as o, jsx as e } from "react/jsx-runtime";
import "react";
import { classes as t } from "../../utils/helpers.js";
import '../../assets/Loading.css';const d = "_spinner_4d38k_14", r = {
  "spinner-wrap": "_spinner-wrap_4d38k_14",
  spinner: d,
  "loading-wrapper__message": "_loading-wrapper__message_4d38k_44"
};
function m({
  spinnerColor: s = "var(--theme-color-100)",
  spinnerSize: a = "3.125rem",
  spinnerTrackWidth: i = "6px",
  topOffset: p = "50%",
  message: n = ""
}) {
  return /* @__PURE__ */ o("loading-wrapper", { style: {
    "--spinner-size": a,
    "--spinner-track-width": i,
    "--spinner-color": s,
    "--spinner-top-offset": p
  }, children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: r["spinner-wrap"],
        "data-state": "entering",
        children: /* @__PURE__ */ e("div", { className: r.spinner })
      }
    ),
    n !== "" && /* @__PURE__ */ e("div", { className: t([r["loading-wrapper__message"], "loading-wrapper__message"]), children: n })
  ] });
}
export {
  m as Loading,
  m as default
};
